<template>
        <div class="form-group">
            <multiselect 
                class="city-select" 
                :class="inputClasses"
                :name="name"
                :id="id"                
                :label="label"
                :autocomplete="autocomplete"
                :placeholder="placeholder" 
                :options="options"
                :clearable="clearable"
                :searchable="searchable || filterable"
                :multiple="multiple"
                :disabled="disabled"
                :allow-empty="allowEmpty"
                :selectLabel="null"
                :selectGroupLabel="null"
                :selectedLabel="null"
                :deselectLabel="null"
                :deselectGroupLabel="null"
                :group-values="groupValues" 
                :group-label="groupLabel" 
                :group-select="groupSelect"
                :track-by="trackBy"

                v-model="valueCopy"

                @input="handleModelInput"
                @remove="handleRemove"
                @open="handleFocus(true)" 
                @close="handleFocus(false)" 
            >                   
            </multiselect>
            <label class="material-label" :class="activeClass" :for="id">
              <slot></slot>
            </label>
            <small v-if="error" class="invalid-feedback">{{ error }}</small>
        </div>

</template>

<script>
    import Multiselect from 'vue-multiselect';
    // import Multiselect from 'vue-multiselect/src/index.js'

  export default {
    name: 'material-select2',
    components: {
        Multiselect
    },
    computed: {
      computedErrors () {
        return typeof this.errorMessages === 'string'
          ? [this.errorMessages] : this.errorMessages
      },
      computedClasses () {
        return {            
          'material--active': this.focus,
          'material--disabled': this.disabled,
          'material--has-errors': Boolean(
            !this.valid ||
            (this.errorMessages && this.errorMessages.length)),
          'material--raised': Boolean(
            this.focus ||
            this.hasValue || // has value
            (this.placeholder && !this.hasValue)), // has placeholder
        }
      },
      activeClass () {
        return {
          'active': Boolean(
            this.focus ||
            this.hasValue || // has value
            (this.placeholder && !this.hasValue)) // has placeholder
        }
      },
      hasValue () {
        return this.multiple ? this.valueCopy && this.valueCopy.length>0 : this.valueCopy;
      },
    },
    data () {
      return {
        valueCopy: null,
        focus: false,
        valid: true
      }
    },
    beforeMount () {
      this.copyValue(this.value)
    },
    methods: {
      handleModelInput (value, id) {
        // console.log(value);
        // console.log(id);
        // console.log(this.valueCopy);
        this.$emit('input', value)
        this.handleValidation()
      },
      handleRemove (removedOption, id) {
        // console.log(removedOption);
        // console.log(id);
      },
      handleFocus (focused) {
        this.focus = focused
      },
      handleValidation () {
        this.valid = true; //this.$el ? this.$el.querySelector('.city-select').validity.valid : this.valid
      },
      copyValue (value) {
        this.valueCopy = value;
        this.handleValidation()
      },      
    },
    watch: {
      value (newValue) {
        // This watch works from the code side of the 2-way-binding:
        this.copyValue(newValue)
      }
    },
    props: {
      id: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      value: {
        default: null
      },
      options: {
        type: Array,
        default() {
            return [];
        }
      },
      label: {
        type: String,
        default: "label"
      },
      trackBy: {
        type: String,
        default: "id"
      },
      allowEmpty: {
        type: Boolean,
        default: true
      },
      placeholder: {
        type: String,
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      searchable: {
        type: Boolean,
        default: true
      },
      clearOnSelect: {
        type: Boolean,
        default: true
      },
      hideSelected: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      groupSelect: {
        type: Boolean,
        default: false
      },
      groupValues: {
        type: String,
      },
      groupLabel: {
        type: String,
      },
      filterable: {
        type: Boolean,
        default: true
      },
      required: {
        type: Boolean,
        default: false
      },
      autocomplete: {
        type: String,
        default: 'off'
      },
      errorMessages: {
        type: [Array, String],
        default: null
      },
      error: {
        type: String,
        default: null
      },
      inputClasses: {
        type: [Array, Object, String],
        default: null
      },
    }
  }
</script>

<style scoped lang="scss">
</style>